import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import KeyboardReturnRoundedIcon from "@mui/icons-material/KeyboardReturnRounded";
import { Box, Divider, Stack, Typography } from "@mui/material";
import type { PublicCheckoutSession } from "../api/types";
import { formatAmount, formatExpiresAt } from "../utils/format";
import { MerchantIdentity } from "./MerchantIdentity";

interface Props {
  session: PublicCheckoutSession;
}

export function SessionSummary({ session }: Props) {
  const ui = session.uiConfig ?? {};
  // El ERP manda el nombre comercial (fantasía) cuando lo tiene; el del gateway
  // es el de alta del merchant y puede estar menos cuidado.
  const nombre = ui.merchantDisplayName?.trim() || session.merchantName;

  return (
    <Box>
      <MerchantIdentity name={nombre} logoUrl={ui.logoUrl} brandColor={ui.brandColor} />

      <Divider sx={{ my: 2 }} />

      <Typography variant="h4" fontWeight={700} sx={{ mb: 0.5 }}>
        {formatAmount(session.amount, session.currency, ui.locale)}
      </Typography>

      {session.description ? (
        <Typography variant="body2" color="text.secondary">
          {session.description}
        </Typography>
      ) : null}

      <Stack spacing={0.75} mt={2}>
        {session.expiresAt ? (
          <Stack direction="row" alignItems="center" spacing={0.75}>
            <AccessTimeRoundedIcon sx={{ fontSize: 15, color: "text.secondary" }} />
            <Typography variant="caption" color="text.secondary">
              Vence {formatExpiresAt(session.expiresAt, ui.locale)}
            </Typography>
          </Stack>
        ) : null}

        {/* Saber que hay camino de vuelta baja el abandono: el comprador llegó
            acá por una redirección y no sabe si va a poder volver. */}
        {session.returnUrl ? (
          <Stack direction="row" alignItems="center" spacing={0.75}>
            <KeyboardReturnRoundedIcon sx={{ fontSize: 15, color: "text.secondary" }} />
            <Typography variant="caption" color="text.secondary">
              Al terminar volvés a {nombre}
            </Typography>
          </Stack>
        ) : null}
      </Stack>
    </Box>
  );
}
